import { useCallback, useEffect, useState } from 'react'
import { CarePartnerResponseDTO, CarePartnersService } from '../client'

export const useCarePartnerByPatient = (patientId?: string) => {
    const [carePartner, setCarePartner] = useState<CarePartnerResponseDTO | null>(null)
    const [loading, setLoading] = useState<boolean>(false)
    const [error, setError] = useState<string | null>(null)

    const fetchCarePartner = useCallback(async () => {
        if (!patientId) {
            setCarePartner(null)
            return
        }

        setLoading(true)
        setError(null)

        try {
            const response = await CarePartnersService.getCarePartnerByPatientCarePartnersByPatientPatientIdGet({
                patientId
            })
            setCarePartner(response)
        } catch (err) {
            // If no care partner is found, set to null (this is expected for patients without care partners)
            if (err instanceof Error && err.message.includes('404')) {
                setCarePartner(null)
            } else {
                setError('Failed to fetch care partner information')
            }
        } finally {
            setLoading(false)
        }
    }, [patientId])

    useEffect(() => {
        fetchCarePartner()
    }, [fetchCarePartner])

    return { carePartner, loading, error, refetch: fetchCarePartner }
}
